export default "__VITE_ASSET__DBH50RFd__"